<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f" @click="toShowTime">
        <input type="text" class="inp-s" v-model="time" @input="validate" placeholder="请选择时间" readonly>
        <van-icon name="calender-o" class="arrow-down" />
    </div>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
    <van-datetime-picker v-model="currentTime" type="time" v-if="showTime" @confirm="confirm" @cancel="cancel" />
</section>
</template>

<script>
import { DatetimePicker, Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-datetime-picker": DatetimePicker,
    "van-icon": Icon
  },
  data() {
    return {
      showTime: false,
      time: "",
      showError: false,
      currentTime: "12:00"
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.time
      };
      return options;
    },
    toShowTime() {
      this.showTime = true;
    },
    confirm(time) {
      this.time = time;
      this.showTime = false;
      this.validate();
    },
    cancel(params) {
      this.showTime = false;
      // console.log(params)
    },
    validate() {
      if (this.transProp.required) {
        if (!this.time) {
          this.showError = true;

          return { label: this.transProp.label, boo: true };
        } else {
          this.showError = false;
          return { label: this.transProp.label, boo: false };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .inp-f {
    margin: 8px 0;
    position: relative;

    .inp-s {
      color: #999090;
    }

    .arrow-down {
      font-size: 40px;
      color: #999090;
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
